import { Card } from '@hyperflake/react-ui-library';
import useClientListData from 'modules/clients/hooks/useClientListData';
import ClientList from 'modules/notification/components/ClientList/ClientList';
import ClientNotificationForm from 'modules/notification/components/ClientNotificationForm/ClientNotificationForm';
import { useState } from 'react';

const ClientNotificationDetailPage = () => {
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const { clients, isLoading } = useClientListData();
    const [searchValue, setSearchValue] = useState('');

    const resetState = () => {
        setSelectedIds([]);
        setSelectAllChecked(false);
        setSearchValue('');
    };

    return (
        <Card className="mt-6">
            <Card.Body>
                <div className="grid grid-cols-12 gap-8">
                    <div className="col-span-5 border-r pr-8">
                        <ClientNotificationForm clients={clients} selectedIds={selectedIds} resetState={resetState} />
                    </div>
                    <div className="col-span-7">
                        <ClientList
                            clients={clients}
                            isLoading={isLoading}
                            selectedIds={selectedIds}
                            setSelectedIds={setSelectedIds}
                            selectAllChecked={selectAllChecked}
                            setSelectAllChecked={setSelectAllChecked}
                            searchValue={searchValue}
                            setSearchValue={setSearchValue}
                        />
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default ClientNotificationDetailPage;
